module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"policy":"Privatumo politika","recaptcha":"Ši svetainė yra apsaugota reCAPTCHA, galioja Google {policy} ir {terms}.","terms":"Sąlygos"}}')
  delete Component.options._Ctor
}
